import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

/** Extends the standard NetworkInformation with the non-standard fields */
interface NetworkInformation extends EventTarget {
  effectiveType?: '2g' | '3g' | '4g' | 'slow-2g';
  saveData?: boolean;
}

@Injectable({ providedIn: 'root' })
export class NetworkAwarePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    /** Opt a specific route out of preloading via data: { preload: false } */
    if (route.data?.['preload'] === false) {
      return of(null);
    }

    const connection: NetworkInformation | undefined =
      (navigator as unknown as { connection?: NetworkInformation }).connection;

    if (!connection) {
      // API not available — safe to preload (likely desktop/fast env)
      return load();
    }

    if (connection.saveData) {
      return of(null);
    }

    switch (connection.effectiveType) {
      case '4g':
        return load();
      case '3g':
      case '2g':
      case 'slow-2g':
        return of(null);
      default:
        return load();
    }
  }
}
